import displayNotification from './DisplayNotification'

const handleError = (errorString) => {
    displayNotification(errorString, 0)
}

export default handleError